/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { getAgent } from './agent';
import { logger as log } from '@common/logger';
const is = require('is_js');

export class NewBatchSerializationPageService {
  private static instance: NewBatchSerializationPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): NewBatchSerializationPageService {
    if (!NewBatchSerializationPageService.instance) {
      NewBatchSerializationPageService.instance =
        new NewBatchSerializationPageService(props);
    }
    return NewBatchSerializationPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    const agent = getAgent();

    return await agent.getPageContent({});
  }

  public async createBatchSerialization(args: any) {
    const agent = getAgent();

    return await agent.createBatchSerialization(args);
  }
}
